import { carrotClient } from "#/utils/CarrotClient"
import { useMutation, UseMutationResult } from "@tanstack/react-query"

export function useTelemedicineInterest(): UseMutationResult<void, unknown, void> {
  return useMutation(() => carrotClient.createTelemedicineInterest(), {
    retry: false
  })
}
